import type { Pack } from '@/app/sites'
import { cn } from '@/lib/utils'

export function PackBadge({ pack }: { pack: Pack }) {
  return (
    <span
      className={cn(
        'rounded px-1.5 py-0.5 font-display text-[11px] font-semibold',
        pack === 'BESS' ? 'bg-stable/20 text-clear' : 'bg-ignition/[0.14] text-flare',
      )}
    >
      {pack}
    </span>
  )
}
